import { HermesError } from '@kaligo/hermes';

export class HermesAuthError extends Error {
  constructor(public error: HermesError) {
    super(`${error.code} ${error.message}`);
    this.name = 'HermesAuthError'; // prevents sending a minified class name to Sentry
  }

  get fingerprint(): string {
    return this.error.code;
  }
}
